import { Moment } from 'moment-timezone'

import { ExternalSchoolFields } from 'main/gql/externalSchool'
import { GatheringFields } from 'main/gql/gathering'
import { SchoolListingType } from 'main/gql/globalTypes'
import { IHydratedLead } from 'main/gql/lead'
import { ISchool, ISchoolWithProfile, ISchoolWithRatings } from 'main/gql/school'
import { CalloutSchoolListingFields } from './gql'

export type School = ISchool & ISchoolWithProfile & ISchoolWithRatings

// Lead status

export interface ILeadStatus {
  type: LeadStatusType
  lead: IHydratedLead
  onRequestOpenScheduleTourModal: () => void
  onRequestOpenCancelTourRequestModal: () => void
}

export enum LeadStatusType {
  Toured = 'toured',
  Scheduled = 'tour_scheduled',
  Enrolled = 'enrolled',
  Unscheduled = 'unscheduled',
}

// Target

export enum TargetType {
  ExternalSchool = 'external_school',
  School = 'school',
  SchoolListing = 'school_listing',
}

export interface IExternalSchoolTarget {
  _type: TargetType.ExternalSchool
  externalSchool: ExternalSchoolFields
}

export interface ISchoolTarget {
  _type: TargetType.School
  school: School
}

export interface ISchoolListingTarget {
  _type: TargetType.SchoolListing
  listing: CalloutSchoolListingFields
}

export type Target = IExternalSchoolTarget | ISchoolTarget | ISchoolListingTarget

// Lazy target

export enum LazyTargetType {
  School = 'school',
  SchoolListing = 'school_listing',
}

export interface ILazySchoolTarget {
  _type: LazyTargetType.School
  id: number
}

export interface ILazySchoolListingTarget {
  _type: LazyTargetType.SchoolListing
  id: number
  type: SchoolListingType
}

export type LazyTarget = ILazySchoolTarget | ILazySchoolListingTarget

// Target data

export interface ITargetData {
  hours: {
    start: string
    end: string
  } | null
  imageUrl: string | null
  isVerified: boolean
  name: string
  pagePath: string
  philosophy: string | null
  pricing: {
    min: number
    max: number
    weeklyMin: number | null
    weeklyMax: number | null
  } | null
  programType: string | null
  rating: {
    overall: number | null
    count: number
  } | null
  networkRating: number | null
  whitelabelRating: {
    label: string
    slug: string
    symbolCount: number | null
  } | null
}

// Upcoming event

export enum UpcomingEventType {
  Gathering = 'gathering',
  Tour = 'tour',
}

interface IUpcomingGatheringEvent {
  __type: UpcomingEventType.Gathering
  gathering: GatheringFields
}

interface IUpcomingTourEvent {
  __type: UpcomingEventType.Tour
  beginsAt: Moment
}

export type UpcomingEvent = IUpcomingGatheringEvent | IUpcomingTourEvent
